import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { 
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import AddTipoGasto from './AddTipoGasto';
import { useAccesos } from '../contexts/AccesosContext';

function GestionTipoGasto() {

    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [tipoGastos, setTipoGastos] = useState([]);
    const [editTipoGasto, setEditTipoGasto] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [tipoGastoToDelete, setTipoGastoToDelete] = useState(null);
    const { user } = useUser();   
    const { tienePermiso } = useAccesos();


    const fetchTiposGastos = async () => {
            try {
                const response = await fetch(`${server}/CrmTipoGastoCampaniums`);
                const data = await response.json();
                setTipoGastos(data.$values);
                
            } catch (error) {
                console.error('Error al cargar los Tipos de gastos:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar los Tipos de gastos: ' + error,
                });
            }
        };

    
    
        useEffect(() => {
            fetchTiposGastos();
        }, []);
    
        const handleNewTipoGasto = () => {
            fetchTiposGastos();
            setEditTipoGasto(null);
        };
    
        const handleChangePage = (event, newPage) => {
            setPage(newPage);
        };
    
        const handleChangeRowsPerPage = (event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
        };
    
        const handleSearchChange = (event) => {
            setSearchQuery(event.target.value);
        };
    
        const handleOpenDialog = (tipoGasto) => {
            setTipoGastoToDelete(tipoGasto);
            setOpenDialog(true);
        };
    
        const handleCloseDialog = () => {
            setOpenDialog(false);
            setTipoGastoToDelete(null);
        };
    
        const handleDeleteTipoGasto = async () => {
            if (tipoGastoToDelete) {
                try {
                    const username = ''+user.codigoUsuario+'/';
    
                    const response = await fetch(`${server}/CrmTipoGastoCampaniums/${tipoGastoToDelete.id}/${username}`,
                         {
                        method: 'DELETE'
                    });
                    if (response.ok) {
                        handleCloseDialog();
                        fetchTiposGastos(); // Recargar la lista de razas
                        Swal.fire({
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Tipo de Gasto eliminado con éxito',
                        });
                    } else {
                        handleCloseDialog();
    
                        const errorData = await response.json();
                        const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                        Swal.fire({
                            icon: 'error',
                            title: `Error ${response.status}`,
                            text: errorMessage,
                        });
                    }
                } catch (error) {
                    console.error('Error al eliminar el tipo de gasto:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al eliminar el tipo de gasto: ' + error,
                    });            }
            }
        };
    
        const filteredTipoGasto = tipoGastos.filter(tipoGasto => tipoGasto.tipoGasto?.toLowerCase().includes(searchQuery.toLowerCase()));
    
   const handleCancelarEdicion = () => {
        setEditTipoGasto(null);
   };

        return (
    <>
        <div className="x_title">
            </div>

            <div className="x_content">
                <br />

                <AddTipoGasto handleNewTipoGasto={handleNewTipoGasto} editTipoGasto={editTipoGasto} cancelarEdicion={handleCancelarEdicion} />

                <div className="ln_solid" />

                <h2>Tipos de Gastos existentes</h2>

                <div className="row">
                    <div className="col-md-6 col-sm-4 offset-md-3">
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Buscar Tipo de Gasto"
                            placeholder="Buscar..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />

                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Descripción</TableCell>
                                            <TableCell align="right">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredTipoGasto.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((tipoGasto) => (
                                                <TableRow key={tipoGasto.id}>
                                                    <TableCell component="th" scope="row">
                                                        {tipoGasto.tipoGasto}
                                                    </TableCell>
                                                    <TableCell align="right">
                                                        <Button onClick={() => setEditTipoGasto(tipoGasto)} color="primary" disabled={!tienePermiso('Editar Tipo Gasto')}>
                                                            Editar
                                                        </Button>
                                                        <Button onClick={() => handleOpenDialog(tipoGasto)} color="secondary" disabled={!tienePermiso('Eliminar Tipo Gasto')}>
                                                            Eliminar
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        
                                    </TableBody>
                                </Table>

                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredTipoGasto.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>

                            <Dialog open={openDialog}
                                onClose={handleCloseDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description">
                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que quieres eliminar este tipo de gasto?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                    <Button onClick={handleDeleteTipoGasto} color="primary" autoFocus>Eliminar</Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
            </div>
        </>

     
    );
}

export default GestionTipoGasto;